import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { CsiApp } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
import { loadGoogleMapsApi } from "./app/common/maps/google-maps-loader";

import { defineCustomElements } from "@ionic/pwa-elements/loader";

if (environment.production) {
  enableProdMode();
}

// Antes de arrancar la app, como el <script> que estaba en index.html
loadGoogleMapsApi(environment.googleMaps.apiKey);

bootstrapApplication(CsiApp, appConfig).catch((err) => console.log(err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
